(function () {
  const roots = document.querySelectorAll('[data-affiliate-hero]');
  if (!roots.length) return;

  roots.forEach(initHero);

  function initHero(root) {
    const canvas = root.querySelector('.affiliate-hero__canvas');
    if (!canvas) return;

    const SETTINGS = {
      gradientStart: root.dataset.gradientStart,
      gradientEnd:   root.dataset.gradientEnd,
      accent:        root.dataset.accent,
      mouseReactive: root.dataset.mouseReactive === 'true',
      intensity:     root.dataset.intensity
    };

    function waitForThree() {
      return new Promise((resolve, reject) => {
        let tries = 0;
        (function check() {
          if (window.THREE) return resolve(window.THREE);
          if (tries++ > 120) return reject(new Error('Three.js not loaded'));
          setTimeout(check, 50);
        })();
      });
    }

    waitForThree().then(THREE => {
      // Auf Mobile drastisch reduzieren: jede Sphere ist ein MeshPhysicalMaterial mit transmission
      // + iridescence — GPU-schwer. Weniger Spheres + weniger Polys = spürbar weniger Paint-Last,
      // optisch kaum Unterschied bei kleinem Viewport.
      const isSmall = window.matchMedia('(max-width: 749px)').matches;
      const counts = isSmall
        ? { subtle: 8,  medium: 14, strong: 20 }
        : { subtle: 14, medium: 28, strong: 40 };
      const COUNT = counts[SETTINGS.intensity] || counts.medium;
      // DPR-Cap auf 1.5 auch Desktop — bei den vielen iridescent-PBR-Pixeln spart das ~25%
      // Fragment-Shader-Last bei kaum sichtbarem Schärfeverlust.
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);

      let width = 1, height = 1, aspect = 1;

      const scene = new THREE.Scene();
      const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 100);
      camera.position.z = 5;

      const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
      renderer.setPixelRatio(dpr);
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.0;

      // environment texture mit kontrastreichem gold-gradient + dunklem horizont-streifen
      function buildEnv() {
        const size = 512;
        const c = document.createElement('canvas');
        c.width = size; c.height = size;
        const cx = c.getContext('2d');
        const g = cx.createLinearGradient(0, 0, 0, size);
        g.addColorStop(0,    '#fff9e6');
        g.addColorStop(0.15, '#f8e4b0');
        g.addColorStop(0.3,  '#2a1a08');
        g.addColorStop(0.5,  '#4a3014');
        g.addColorStop(0.7,  '#e9c783');
        g.addColorStop(0.88, '#b98d3e');
        g.addColorStop(1,    '#3d2a12');
        cx.fillStyle = g; cx.fillRect(0, 0, size, size);
        cx.globalAlpha = 0.85;
        cx.fillStyle = '#ffe9a8';
        cx.beginPath(); cx.arc(size * 0.28, size * 0.18, size * 0.12, 0, Math.PI * 2); cx.fill();
        cx.beginPath(); cx.arc(size * 0.72, size * 0.25, size * 0.08, 0, Math.PI * 2); cx.fill();
        cx.globalAlpha = 1;
        cx.fillStyle = '#ffffff';
        cx.beginPath(); cx.arc(size * 0.42, size * 0.10, size * 0.05, 0, Math.PI * 2); cx.fill();
        cx.beginPath(); cx.arc(size * 0.60, size * 0.60, size * 0.04, 0, Math.PI * 2); cx.fill();
        const tex = new THREE.CanvasTexture(c);
        tex.mapping = THREE.EquirectangularReflectionMapping;
        tex.encoding = THREE.sRGBEncoding;
        return tex;
      }
      scene.environment = buildEnv();

      scene.add(new THREE.AmbientLight(0xffffff, 0.35));
      const keyLight = new THREE.DirectionalLight(0xffffff, 1.1);
      keyLight.position.set(-2, 3, 4);
      scene.add(keyLight);
      const rimLight = new THREE.DirectionalLight(0xffffff, 0.55);
      rimLight.position.set(2, -1, 2);
      scene.add(rimLight);

      // Zwei-Material-Strategie: nur die großen Hero-Bubbles (≥0.14 radius) bekommen die volle
      // PBR-Pipeline mit Transmission + Attenuation. Die ~80% kleinen Bubbles laufen auf einem
      // billigeren Material (kein Transmission, niedriger Thickness, uniform Iridescence) —
      // visuell auf dieser Größe nicht unterscheidbar, GPU-Cost ein Bruchteil.
      const glassHero = new THREE.MeshPhysicalMaterial({
        color: 0xfff3d6,
        transmission: 1.0,
        roughness: 0.03,
        thickness: 0.55,
        ior: 1.38,
        clearcoat: 1.0,
        clearcoatRoughness: 0.06,
        metalness: 0.0,
        attenuationColor: new THREE.Color(SETTINGS.accent),
        attenuationDistance: 0.38,
        envMapIntensity: 1.9,
        transparent: true,
        iridescence: 0.9,
        iridescenceIOR: 1.3,
        iridescenceThicknessRange: [300, 300]
      });
      const glassSimple = new THREE.MeshPhysicalMaterial({
        color: 0xffffff,
        transmission: 1.0,
        roughness: 0.04,
        thickness: 0.25,
        ior: 1.34,
        clearcoat: 1.0,
        clearcoatRoughness: 0.05,
        metalness: 0.0,
        envMapIntensity: 1.6,
        transparent: true,
        iridescence: 0.85,
        iridescenceIOR: 1.3,
        iridescenceThicknessRange: [300, 300]
      });

      // Sphere-Segments deutlich runter — bei Bubble-Radien ≤0.22 sind 24 Segmente visuell
      // identisch zu 48, aber Vertex-Count fällt um Faktor 4.
      const sphereSegments = isSmall ? 14 : 24;
      const geo = new THREE.SphereGeometry(1, sphereSegments, sphereSegments);
      const spheres = [];

      function rand(a, b) { return a + Math.random() * (b - a); }

      const SOURCES = [-0.85, -0.15, 0.55, 1.05];

      function spawn(sphere, initial) {
        const isHero = Math.random() < 0.2;
        const radius = isHero ? rand(0.14, 0.22) : rand(0.025, 0.08);
        // Material je nach Größe wechseln — der größte Strukturhebel
        sphere.material = isHero ? glassHero : glassSimple;
        let x;
        if (!isHero && Math.random() < 0.75) {
          const src = SOURCES[Math.floor(Math.random() * SOURCES.length)];
          x = src + rand(-0.1, 0.1);
        } else {
          x = rand(-1.3, 1.3);
        }
        sphere.scale.setScalar(radius);
        sphere.userData = {
          baseX: x,
          y: initial ? rand(-1.1, 1) : -1.1 - radius - rand(0, 0.3),
          speed: isHero ? rand(0.00012, 0.00022) : rand(0.00028, 0.0006),
          wiggleAmp: isHero ? rand(0.006, 0.022) : rand(0.018, 0.042),
          wigglePhase: rand(0, Math.PI * 2),
          wiggleSpeed: isHero ? rand(0.0003, 0.0007) : rand(0.0005, 0.0012),
          radius,
          vx: 0, vy: 0,
          hoverPulse: 0
        };
      }

      for (let i = 0; i < COUNT; i++) {
        const m = new THREE.Mesh(geo, glassSimple);
        spawn(m, true);
        scene.add(m);
        spheres.push(m);
      }

      // geysir-emitter — alle Geyser-Bubbles sind klein (radius 0.018–0.055), kriegen das billige
      // Simple-Material. Pool 100→50 (Desktop), 30→20 (Mobile).
      const GEYSER_POOL_SIZE = isSmall ? 20 : 50;
      const geyserPool = [];
      for (let i = 0; i < GEYSER_POOL_SIZE; i++) {
        const m = new THREE.Mesh(geo, glassSimple);
        m.visible = false;
        m.userData = { active: false };
        scene.add(m);
        geyserPool.push(m);
      }

      function spawnGeyserBubble(g) {
        let b = null;
        for (let i = 0; i < geyserPool.length; i++) {
          if (!geyserPool[i].userData.active) { b = geyserPool[i]; break; }
        }
        if (!b) return;
        const radius = rand(0.018, 0.055);
        b.scale.setScalar(radius);
        b.visible = true;
        b.userData = {
          active: true,
          baseX: g.x + rand(-0.1, 0.1),
          y: -1.15 - radius,
          speed: rand(0.0011, 0.0020),
          wiggleAmp: rand(0.025, 0.07),
          wigglePhase: rand(0, Math.PI * 2),
          wiggleSpeed: rand(0.0010, 0.0020),
          radius,
          life: 0,
          maxLife: 5500 + Math.random() * 3500,
          vx: 0, vy: 0,
          hoverPulse: 0
        };
      }

      const geyserNow = performance.now();
      const GEYSERS = [
        { x: -1.10, burstSize: 14, burstDuration: 820, interval: 4400, currentBurst: null, nextFire: 0 },
        { x: -0.55, burstSize: 16, burstDuration: 900, interval: 5100, currentBurst: null, nextFire: 0 },
        { x:  0.05, burstSize: 18, burstDuration: 950, interval: 3800, currentBurst: null, nextFire: 0 },
        { x:  0.60, burstSize: 13, burstDuration: 780, interval: 5500, currentBurst: null, nextFire: 0 },
        { x:  1.05, burstSize: 15, burstDuration: 850, interval: 4200, currentBurst: null, nextFire: 0 }
      ];

      // initial mega-burst beim page-load — "wasserflasche aufmachen" effekt
      // Reduziert (32→20 Desktop, 10→6 Mobile): Pool ist kleiner, sonst läuft er sofort über.
      for (const g of GEYSERS) {
        g.currentBurst = {
          spawned: 0,
          total: isSmall
            ? 6 + Math.floor(Math.random() * 4)
            : 20 + Math.floor(Math.random() * 8),
          nextSpawn: geyserNow,
          duration: 1900 + Math.random() * 600
        };
        g.nextFire = geyserNow + 3800 + Math.random() * 2000;
      }

      // Shockwave + Orbital-Swirl Hover-Effekt:
      //   HOVER_R       — Wirkradius um Cursor
      //   HOVER_RADIAL  — Repulsion-Stärke (push away)
      //   HOVER_TANG    — Tangential-Stärke (Swirl, ⊥ zur Radial-Richtung → CCW-Wirbel)
      //   PULSE_GROW    — wie schnell betroffene Bubbles auf-pulsieren (per ms)
      //   PULSE_DECAY   — wie schnell der Pulse nach Verlassen abklingt (per Frame)
      //   PULSE_AMP     — max Scale-Boost am Pulse-Peak (18% größer)
      const HOVER_R      = 0.6;
      const HOVER_RADIAL = 0.0028;
      const HOVER_TANG   = 0.0014;
      const PULSE_GROW   = 0.012;
      const PULSE_DECAY  = 0.94;
      const PULSE_AMP    = 0.18;

      const mouse = { x: 0, y: 0, active: false };
      // Auf Touch-Geräten wäre jeder Scroll ein pointermove → Scroll-Jank. Nur auf echten Maus-Geräten registrieren.
      const hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (SETTINGS.mouseReactive && hasFinePointer) {
        root.addEventListener('pointermove', e => {
          if (e.pointerType !== 'mouse') return;
          const r = root.getBoundingClientRect();
          mouse.x = (((e.clientX - r.left) / r.width) * 2 - 1) * aspect;
          mouse.y = -(((e.clientY - r.top) / r.height) * 2 - 1);
          mouse.active = true;
        });
        root.addEventListener('pointerleave', () => { mouse.active = false; });
      }

      function resize() {
        const r = root.getBoundingClientRect();
        width = r.width; height = r.height;
        aspect = width / height;
        camera.left = -aspect;
        camera.right = aspect;
        camera.top = 1;
        camera.bottom = -1;
        camera.updateProjectionMatrix();
        renderer.setSize(width, height, false);
      }
      resize();
      let rt; window.addEventListener('resize', () => {
        clearTimeout(rt);
        rt = setTimeout(resize, 180);
      });

      let rafId = null, paused = false, lastT = performance.now();

      function frame(t) {
        const dt = Math.min(t - lastT, 50);
        lastT = t;

        for (const s of spheres) {
          const d = s.userData;
          const wig = Math.sin(t * d.wiggleSpeed + d.wigglePhase) * d.wiggleAmp;
          let x = d.baseX + wig;

          if (SETTINGS.mouseReactive && mouse.active) {
            const dx = x - mouse.x;
            const dy = d.y - mouse.y;
            const distSq = dx * dx + dy * dy;
            if (distSq < HOVER_R * HOVER_R && distSq > 0.0001) {
              const dist = Math.sqrt(distSq);
              const norm = 1 - dist / HOVER_R;
              const ux = dx / dist, uy = dy / dist;
              // Radial: weg vom Cursor (Shockwave)
              d.vx += ux * norm * HOVER_RADIAL * dt;
              d.vy += uy * norm * HOVER_RADIAL * dt;
              // Tangential: ⊥ zur Radial-Richtung → Bubbles spiralen CCW um den Cursor
              d.vx += -uy * norm * HOVER_TANG * dt;
              d.vy +=  ux * norm * HOVER_TANG * dt;
              // Visual feedback: Scale-Pulse hochfahren
              d.hoverPulse = Math.min(1, d.hoverPulse + norm * dt * PULSE_GROW);
            }
          }
          d.vx *= 0.93;
          d.vy *= 0.93;
          d.hoverPulse *= PULSE_DECAY;

          d.y += d.speed * dt + d.vy * 0.02;
          s.position.x = x + d.vx;
          s.position.y = d.y;
          s.scale.setScalar(d.radius * (1 + d.hoverPulse * PULSE_AMP));
          s.rotation.y += 0.002;

          if (d.y > 1.2 + d.radius) spawn(s, false);
        }

        // geysir-update — bursts triggern, bläschen bewegen (mit deflection)
        for (let gi = 0; gi < GEYSERS.length; gi++) {
          const g = GEYSERS[gi];
          if (g.currentBurst) {
            if (t >= g.currentBurst.nextSpawn && g.currentBurst.spawned < g.currentBurst.total) {
              spawnGeyserBubble(g);
              g.currentBurst.spawned++;
              g.currentBurst.nextSpawn = t + g.currentBurst.duration / g.currentBurst.total;
            }
            if (g.currentBurst.spawned >= g.currentBurst.total) {
              g.currentBurst = null;
              g.nextFire = t + g.interval + (Math.random() - 0.5) * 1500;
            }
          } else if (t >= g.nextFire) {
            g.currentBurst = {
              spawned: 0,
              total: g.burstSize + Math.floor(Math.random() * 7 - 2),
              nextSpawn: t,
              duration: g.burstDuration + (Math.random() - 0.5) * 400
            };
          }
        }
        for (let i = 0; i < geyserPool.length; i++) {
          const b = geyserPool[i];
          const d = b.userData;
          if (!d.active) continue;
          d.life += dt;

          // deflection — weiche abstoßung von main-bläschen.
          // Early-Exit auf y-Diff vor sqrt: spart in der Praxis ~70-80% der distanz-checks,
          // weil die meisten Geyser-Bubble/Sphere-Paare vertikal weit auseinander liegen.
          for (let si = 0; si < spheres.length; si++) {
            const s = spheres[si];
            const sd = s.userData;
            const minDist = sd.radius + d.radius + 0.05;
            const dy = b.position.y - s.position.y;
            if (dy > minDist || dy < -minDist) continue;
            const dx = b.position.x - s.position.x;
            if (dx > minDist || dx < -minDist) continue;
            const distSq = dx * dx + dy * dy;
            if (distSq < minDist * minDist && distSq > 0.0001) {
              const dist = Math.sqrt(distSq);
              const push = (1 - dist / minDist) * 0.0015 * dt;
              d.vx += (dx / dist) * push;
              d.vy += (dy / dist) * push * 0.35;
            }
          }
          // Hover-Effekt auch auf Geyser-Bubbles — sonst wirken sie tot inmitten wirbelnder Hauptbubbles
          if (SETTINGS.mouseReactive && mouse.active) {
            const wig = Math.sin(t * d.wiggleSpeed + d.wigglePhase) * d.wiggleAmp;
            const px = d.baseX + wig + d.vx;
            const dx = px - mouse.x;
            const dy = d.y - mouse.y;
            const distSq = dx * dx + dy * dy;
            if (distSq < HOVER_R * HOVER_R && distSq > 0.0001) {
              const dist = Math.sqrt(distSq);
              const norm = 1 - dist / HOVER_R;
              const ux = dx / dist, uy = dy / dist;
              d.vx += ux * norm * HOVER_RADIAL * dt;
              d.vy += uy * norm * HOVER_RADIAL * dt;
              d.vx += -uy * norm * HOVER_TANG * dt;
              d.vy +=  ux * norm * HOVER_TANG * dt;
              d.hoverPulse = Math.min(1, d.hoverPulse + norm * dt * PULSE_GROW);
            }
          }
          d.vx *= 0.92;
          d.vy *= 0.92;
          d.hoverPulse *= PULSE_DECAY;

          const wig = Math.sin(t * d.wiggleSpeed + d.wigglePhase) * d.wiggleAmp;
          d.y += d.speed * dt + d.vy;
          b.position.x = d.baseX + wig + d.vx;
          b.position.y = d.y;
          b.scale.setScalar(d.radius * (1 + d.hoverPulse * PULSE_AMP));
          if (d.y > 1.2 + d.radius || d.life > d.maxLife) {
            d.active = false;
            b.visible = false;
          }
        }

        renderer.render(scene, camera);
        if (!paused) rafId = requestAnimationFrame(frame);
      }

      const io = new IntersectionObserver(entries => {
        for (const e of entries) {
          if (e.isIntersecting) {
            paused = false;
            if (!rafId) { lastT = performance.now(); rafId = requestAnimationFrame(frame); }
          } else {
            paused = true;
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null;
          }
        }
      }, { threshold: 0.05 });
      io.observe(root);

      lastT = performance.now();
      rafId = requestAnimationFrame(frame);
    }).catch(err => {
      console.error('Three.js load failed', err);
    });
  }
})();
